var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDjango(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #edf7f2;\n      }\n\n      .cls-3 {\n        fill: #2caa78;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1.9,
    y: -2.1,
    width: 87.8,
    height: 99.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4803.7-375.5h2500v2500h-2500V-375.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.3,1.7h15.2v69.7c-7.8,1.5-13.5,2.1-19.7,2.1-18.6,0-28.2-8.3-28.2-24.2s10.3-25.3,26.1-25.3,4.3.2,6.6.8V1.7ZM38.8,37.2c-1.8-.6-3.2-.8-5.1-.8-7.7,0-12.1,4.7-12.1,12.9s4.2,12.4,12,12.4,3.1,0,5.2-.4v-24.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M78.4,25.8v34.9c0,12-.9,17.8-3.5,22.8-2.5,4.8-5.7,7.8-12.4,11.1l-14.1-6.6c6.7-3.1,10-5.9,12-10.1,2.2-4.3,2.9-9.3,2.9-22.4v-29.7h15.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.6,1.7h15.2v15.4h-15.2V1.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/Django.1ae40a21502841e944e60d94e0980abd.svg";
export { ForwardRef as ReactComponent };